<template>
  <div class="verify-email">
    <loader/>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import trackingHelper from '@/helpers/trackingHelper'
import localStorageHelper from '@/helpers/localStorageHelper'

export default {
  components: {
    Loader
  },
  mounted()
  {
    if (this.$route && this.$route.query && this.$route.query.success && this.$route.query.success === 'true') {
      trackingHelper.pushEvent('email-verified')
    }
    setTimeout(() =>
    {
      localStorageHelper.set('targetUrl', '/register-complete')
      window.location.href = '/login'
    }, 500)
  }
}
</script>
